export default __webpack_public_path__ + "static/media/SendUSDC.3eb80358.gif";